import type { BillingPeriod } from '@common-components/subscription-selection/subscription-selection';

/**
 * Billing period requested by the link (?period=year). A paid monthly subscriber's picker defaults
 * to Monthly, where a yearly-only coupon (BF2026) does nothing, so campaign links can ask for Yearly.
 */
export function periodFromQuery(raw: string | string[] | undefined): BillingPeriod | undefined {
  if (typeof raw !== 'string') return undefined;
  const v = raw.trim().toLowerCase();
  if (v === 'year' || v === 'yearly' || v === 'annual') return 'year';
  if (v === 'month' || v === 'monthly') return 'month';
  return undefined;
}
